import { Body, Box } from '@hover/blueprint';
import React from 'react';

import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

interface FilteredBySubHeaderProps {
  companyName: string;
}

const FilteredBySubHeader = ({ companyName }: FilteredBySubHeaderProps) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);

  return (
    <Box
      backgroundColor="primary100"
      borderRadius="md"
      marginBottom={300}
      paddingX="400"
      paddingY="100"
      testId="filtered-by-subheader"
    >
      <Body color="neutral600" fontWeight={700} size={300}>
        {t('menu.productsFilteredBy')}&nbsp;
      </Body>
      <Body fontWeight={700} size={300} testId="org-name">
        {companyName}
      </Body>
    </Box>
  );
};

export { FilteredBySubHeader };
